export default function logMiddleware(data, opts) {
  let {pipeName, type, hub} = opts;
  let logData = data;
  let typeMsg = { before: 'in', after: 'out' }[type];

  try {
    let logData = JSON.parse(JSON.stringify(data));
  } catch(e) {
    //
  }

  console.log(`gent-hub log ~ pipe ${typeMsg} <${pipeName}>:`, logData);

  return [data];
}
